import React, { useState } from 'react';
import { Navigate, useNavigate } from 'react-router-dom';

import COLORS from './Components/styles/Colors';
import logo from './caebes-logo.svg';

const EyeIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
    <circle cx="12" cy="12" r="3" />
  </svg>
);

const EyeOffIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24" />
    <line x1="1" y1="1" x2="23" y2="23" />
  </svg>
);

const containerStyle = {
  width: '100vw',
  height: '100vh',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  backgroundColor: COLORS.SLATE700,
};

const alertStyle = {
  width: '100%',
  maxWidth: '300px',
  textAlign: 'center',
  padding: '12px',
  marginTop: '12px',
  borderRadius: '3px',
  backgroundColor: COLORS.RED100,
  color: COLORS.RED700,
};

const formStyle = {
  maxWidth: '600px',
  minHeight: '600px',
  backgroundColor: COLORS.SLATE200,
  borderRadius: '5px',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-around',
  alignItems: 'center',
};

const inputContainerStyle = {
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-around',
  alignItems: 'center',
  height: '120px',
};

const inputStyle = {
  height: '50px',
  width: '300px',
  borderRadius: '3px',
  border: 0,
  margin: '10px',
  fontSize: '20px',
  backgroundColor: COLORS.SLATE50,
};

const buttonStyle = {
  ...inputStyle,
  backgroundColor: COLORS.SLATE500,
  color: COLORS.SLATE50,
  boxShadow: '0 1px 3px hsla(0, 0%, 0%, .2)',
};

const imgStyle = {
  height: '30vh',
};

const loadingContainerStyle = {
  height: '100vh',
  width: '100vw',
  backgroundColor: 'rgba(10,10,10,0.4)',
  position: 'fixed',
  top: 0,
  left: 0,
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  backdropFilter: 'blur(3px)',
};

const Login = ({ isLogged, logIn }) => {
  const navigate = useNavigate();
  const [usuario, setUsuario] = useState('');
  const [pass, setPass] = useState('');
  const [alertMsg, setAlertMsg] = useState('');
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  const enterLogin = async () => {
    try {
      setLoading(true);
      const tryLogin = await logIn(usuario, pass);
      if (tryLogin.error !== false) throw new Error(tryLogin.error);
      setLoading(false);
      navigate('/main');
    } catch (error) {
      console.error(error);
      setLoading(false);
      const errorCode = error?.code ?? undefined;
      switch (errorCode) {
        case 'ERR_NETWORK':
          setAlertMsg('Sin conexión a internet.');
          break;
        default:
          setAlertMsg('Usuario o contraseña incorrectos');
      }
    }
  };

  if (isLogged === 'true') return <Navigate to="/main" replace />;
  return (
    <>
      <div style={containerStyle}>
        <div style={formStyle}>
          <div style={imgStyle}>
            <img src={logo} alt="logo" style={{ height: '100%', width: '100%' }} />
          </div>
          <div style={inputContainerStyle}>
            <input
              type="text"
              name="usuario"
              id="usuario"
              placeholder="usuario"
              style={inputStyle}
              value={usuario}
              onChange={(e) => setUsuario(e.target.value)}
            />
            <div style={{ position: 'relative', width: '300px' }}>
              <input
                type={showPassword ? 'text' : 'password'}
                name="pass"
                id="pass"
                placeholder="contraseña"
                style={{
                  ...inputStyle,
                  margin: 0,
                  paddingRight: '50px',
                  width: '250px',
                }}
                value={pass}
                onChange={(e) => setPass(e.target.value)}
                onKeyDown={(e) => e.code === 'Enter' && enterLogin()}
              />
              <button
                onClick={() => setShowPassword(!showPassword)}
                onMouseDown={(e) => e.preventDefault()}
                type="button"
                style={{
                  position: 'absolute',
                  right: '8px',
                  top: '50%',
                  transform: 'translateY(-50%)',
                  border: 'none',
                  background: 'transparent',
                  cursor: 'pointer',
                  padding: '5px',
                  display: 'flex',
                  alignItems: 'center',
                  color: COLORS.SLATE500,
                }}
              >
                {showPassword ? <EyeOffIcon /> : <EyeIcon />}
              </button>
            </div>
          </div>
          <input type="button" value="Entrar" style={buttonStyle} onClick={enterLogin} />
          {alertMsg !== '' && (
            <div style={alertStyle}>
              {alertMsg}
            </div>
          )}
        </div>
      </div>
      {loading && (
        <div style={loadingContainerStyle}>
          <div className="lds-dual-ring" />
        </div>
      )}
    </>
  );
};

export default Login;
